import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"
import { CardTitle, CardSubtitle } from "reactstrap"
import Img from "gatsby-image"
import site from "../../utilty/getURL"
export default function RecentPost() {
  return (
    <div className="">
      <CardTitle className="text-center bg-white mb-1 p-2 w-100 shadow  border-bottom-1 border-primary">
        <h4>Recent Posts</h4>
      </CardTitle>

      <StaticQuery
        query={SideBarQuery}
        render={data => {
          return (
            <div className="w-100 bg-white ">
              {data.allContentfulBlogPost.edges.map(({ node }) => {
                return (
                  <Link to={`${site.siteMetadata.siteUrl}/${node.slug}`}>
                    <div
                      className="row  m-0 mb-1 w-100 shadow border"
                      key={node.title}
                    >
                      <div className="col-4 pl-0">
                        <Img
                          fluid={node.heroImage.fluid}
                          className="h-100"
                          alt={node.title}
                        />
                      </div>
                      <div className="col-8 w-100">
                        <CardTitle className="mt-2">{node.title}</CardTitle>
                        <CardSubtitle>
                          <span className="text-info">{node.publishDate}</span>
                        </CardSubtitle>
                      </div>
                    </div>
                  </Link>
                )
              })}
            </div>
          )
        }}
      />
    </div>
  )
}

export const SideBarQuery = graphql`
  query RecentIndexQuery {
    allContentfulBlogPost(
      sort: { fields: [publishDate], order: DESC }
      limit: 10
    ) {
      edges {
        node {
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          tags
          heroImage {
            fluid(maxWidth: 350, maxHeight: 196, resizingBehavior: SCALE) {
              ...GatsbyContentfulFluid
              base64
              # tracedSVG
              srcWebp
              srcSetWebp
            }
          }
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`
